import { API } from "./Api";
import axios from "axios";
import Logger from "./Logger";

function getPresignedUrl(filename, size, file_type) {
  return API.post("file/get_presigned_url", { filename, size, file_type });
}

function uploadToS3(url, currentFile, presignedFields, onProgress) {
  const formData = new FormData();
  Object.keys(presignedFields).forEach((element) => {
    formData.append(element, presignedFields[element]);
  });
  formData.append("file", currentFile);

  const options = {
    headers: { "Content-Type": "multipart/form-data" },
  };

  return axios.post(url, formData, options);
}

const S3Upload = async (currentFile, file_type) => {
  try {
    const presignedDataResponse = await getPresignedUrl(currentFile.name, currentFile.size);
    const presignedData = presignedDataResponse.data;

    await uploadToS3(presignedData.url, currentFile, presignedData.fields);

    return {
      file: {
        policy: presignedData.fields.policy,
        signature: presignedData.fields["x-amz-signature"],
      },
      file_type,
      url: `${presignedData.url}/${presignedData.fields.key}`
    };
  } catch (err) {
    Logger.info(err);
    return Promise.reject({"name":currentFile.name, error: err});
  }
};

export default S3Upload;
